module.exports = __webpack_public_path__ + "img/horizontal_3_5_8019.7104c9ec.png";